import React from 'react'

import { ItemListLoadingStyled, LoaderIcon, LoaderItem } from '../../styled'

const ItemListLoader = (): React.ReactElement => (
  <div data-testid="itemlistLoader">
    <ItemListLoadingStyled>
      <LoaderIcon />
      <LoaderItem />
    </ItemListLoadingStyled>
    <ItemListLoadingStyled>
      <LoaderIcon />
      <LoaderItem />
    </ItemListLoadingStyled>
    <ItemListLoadingStyled>
      <LoaderIcon />
      <LoaderItem />
    </ItemListLoadingStyled>
  </div>
)

export default ItemListLoader
